module.exports = __webpack_public_path__ + "media/images/carbon_hospitals/common/qa/male_consulter_unanswered-145ea9c6927c146a46cee42ce3928ff4.png";